import dynamic from "next/dynamic";

export type componentMappingTypes = {
  [Key in string]: Function;
};

/**
 * Map all the cms components here to dynamically display content from cms
 * In the JSON key must match with contentType.id from contentful cms
 */
const componentMapping: componentMappingTypes = {
  TextEditor: dynamic(
    () => import("@Libs/contentful/components/cms-text-editor/CmsTextEditor")
  ),
  Banner: dynamic(
    () => import("@Components/contentful-components/banner/Banner")
  ),
  HomePageHeroSlider: dynamic(
    () =>
      import(
        "@Components/contentful-components/heroSlider/custom/HomePageHeroSlider"
      )
  ),
  HeroSlider: dynamic(
    () => import("@Components/contentful-components/heroSlider/HeroSlider")
  ),
  UserFeedback: dynamic(
    () => import("@Components/contentful-components/user-feedback/UserFeedBack")
  ),
  UserReviews: dynamic(
    () => import("@Components/contentful-components/user-reviews/UserReviews")
  ),
  SalesPropositions: dynamic(
    () =>
      import(
        "@Components/contentful-components/uniqueSalesPropositions/UniqueSalesPropositions"
      )
  ),
  CarouselProductList: dynamic(
    () =>
      import("@Components/contentful-components/promo-carousel/PromoCarousel")
  ),
  Educational: dynamic(
    () => import("@Components/contentful-components/educational/Educational")
  ),
  KnowYourCuts: dynamic(
    () =>
      import("@Components/contentful-components/know-your-cuts/KnowYourCuts")
  ),
  StoriesOfWildfork: dynamic(
    () => import("@Components/storiesOfWildfork/StoriesOfWildfork")
  ),
  MediaImage: dynamic(
    () => import("@Components/contentful-components/media-image/MediaImage")
  ),

  RichTextContent: dynamic(
    () => import("@Components/contentful-components/rich-text/RichTextContent")
  ),

  MembershipTable: dynamic(
    () =>
      import(
        "@Components/contentful-components/membership-table/MembershipTable"
      )
  ),

  MediaEmbedYoutubeVideo: dynamic(
    () =>
      import(
        "@Components/contentful-components/media-embed-youtube-video/MediaEmbedYoutubeVideo"
      )
  ),

  SectionTitleIconDescription: dynamic(
    () =>
      import(
        "@Components/contentful-components/section-title-icon-description/SectionTitleIconDescription"
      )
  ),

  SectionTextImage: dynamic(
    () =>
      import(
        "@Components/contentful-components/section-text-image/SectionTextImage"
      )
  ),

  SectionDivider: dynamic(
    () =>
      import("@Components/contentful-components/section-divider/SectionDivider")
  ),
};

export default componentMapping;
